import '../styles/main.scss';
import '../images/share.jpg';
import Analytics from './analytics';
import WindowEvents from './windowEvents';
import Preloader from '../../partials/components/ge-preloader/ge-preloader';

import './rankingModule';
import './pollModule';
import './linkToTopModule';

const isProduction = location.hostname !== 'localhost' || location.hostname !== '127.0.0.1';
const localBucket = location.href.indexOf('sportv') > 0 ? 'sportv' : 'ge';

(($) => {
  $(document).ready(() => {
    if (isProduction) Analytics.init(localBucket);
    WindowEvents.init();
    Preloader.hide();

    const groupLength = document.getElementById('ranking-list').getAttribute('data-groups-length');
    const groups = document.getElementsByClassName('ranking__list');
    [...groups].forEach((group) => { group.classList.add(`ranking__list--${groupLength / 2}`); });
  });
})(jQuery);

/* istanbul ignore if */
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// local_static/templates/guias/2018/assets/scripts/main.js